import { useEffect, useState } from 'react'

export default function useOpenMenuSetting() {
  const [activeMenuId, setActiveMenuId] = useState(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (activeMenuId !== null && !event.target.closest('.settings-cell')) {
        setActiveMenuId(null)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [activeMenuId])

  return { activeMenuId, setActiveMenuId }
}
